import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {EntityClickEvent} from "../models/events/entity-click-event";
import {UndoClickEvent} from "../models/events/undo.click-event";

export class UndoClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.undoClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = UndoClickEvent;
  }

  async action(params) {
    const currentLinkModelName = params.currentLinkModelName;
    const clickEvent: EntityClickEvent = new UndoClickEvent(params, this.getScreen(currentLinkModelName));

    this.analyticsService.createEvent(clickEvent);
  }
}
